import React from 'react';
import ReactDOM from 'react-dom';
import 'line-awesome/dist/line-awesome/css/line-awesome.css';
import 'animate.css/animate.css';
import './styles/index.generated.css';
import App from './app';
import reportWebVitals from './reportWebVitals';

// inisiasi penerapan REDUX
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import reducers from './redux/reducers';

// set REDUX
const store = createStore(reducers, compose(applyMiddleware(thunk)));

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
    ,
  </React.StrictMode>,
  document.getElementById('root') 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
